<div
  class="flag rounded-circle flag-{{ size }} image-background cover"
  [style.backgroundImage]="'url(assets/img/flags/' + flag + '.svg)'"
></div>
